import React from "react";
import { Trash2 } from "lucide-react";

/**
 * Saved prompt picker. Selecting one only fills the prompt box — the saved
 * prompt changes only when the user clicks "Update saved prompt".
 */
export default function SavedPrompts({ prompts, selectedId, onSelect, isEdited, onUpdate, onDelete, busy, disabled }) {
  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor="ic-saved-prompt" className="text-sm font-medium text-gray-900">
        Saved Prompts
      </label>
      <div className="flex items-center gap-2">
        <select
          id="ic-saved-prompt"
          value={selectedId}
          disabled={disabled}
          onChange={(e) => onSelect(e.target.value)}
          className="min-w-0 flex-1 rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-900 focus:border-indigo-500 focus:outline-none disabled:bg-gray-50"
        >
          <option value="">{prompts.length ? "Select a saved prompt" : "No saved prompts yet"}</option>
          {prompts.map((p) => (
            <option key={p.id} value={p.id}>
              {p.name}
            </option>
          ))}
        </select>
        {selectedId && (
          <button
            type="button"
            onClick={onDelete}
            disabled={busy || disabled}
            aria-label="Delete saved prompt"
            className="rounded-lg border border-gray-200 p-2 text-gray-500 hover:border-red-300 hover:text-red-600 disabled:opacity-50"
          >
            <Trash2 size={15} />
          </button>
        )}
      </div>
      {selectedId && isEdited && (
        <div className="flex flex-wrap items-center justify-between gap-2 rounded-lg bg-amber-50 px-3 py-2 text-xs text-amber-800">
          <span>You've edited this saved prompt. Changes apply to this image only.</span>
          <button
            type="button"
            onClick={onUpdate}
            disabled={busy || disabled}
            className="font-semibold text-amber-900 underline disabled:opacity-50"
          >
            {busy ? "Saving…" : "Update saved prompt"}
          </button>
        </div>
      )}
    </div>
  );
}
